import styles from './FJGradation.module.less';
import classNames from 'classnames';
import React from 'react'

interface Props {
    children: React.ReactNode,
    className?: string,
    active?: boolean,
    radius?: number,
    onClick?: () => void
}

function FJGradation({ children, className, active, radius = 8, onClick }: Props) {
    return (
        <div
            className={classNames(styles.container, className, active && styles.active)}
            style={{
                borderRadius: `${radius}px`,
            }}
            onClick={onClick}
        >
            <i
                className={styles.in_border}
                style={{
                    borderRadius: `${radius - 2}px`,
                }}
            />
            <div className={styles.content} style={{ borderRadius: `${radius}px` }}>
                {children}
            </div>
        </div>
    );
}

export default FJGradation;
